export default __webpack_public_path__ + "static/media/Charmer's Tunic.2f53eb83.jpg";